import storeFactory from '@state/template'

const apiResourceName = 'customers/assets'
const modelName = 'asset'
const model = {
  activated_at: null,
  assigned_at: null,
  brand: null,
  contract_id: null,
  contract_end_at: null,
  contract_start_at: null,
  esim_qr: null,
  iccid: null,
  phone_number: null,
  created_at: null,
  customer_id: null,
  customer_location_id: null,
  customer_user_id: null,
  deleted_at: null,
  file: null,
  has_kasko: false,
  is_spare: false,
  id: null,
  imei: null,
  imei2: null,
  model: null,
  notes: null,
  options: {},
  plans_subscription_id: null,
  product_id: null,
  replaced_by: null,
  replacement_of: null,
  associated_with: null,
  serial_code: null,
  status: null,
  system_id: null,
  system_tof_id: null,
  updated_at: null,
  location: null,
  pin: null,
  puk: null,
}
const filters = {
  customer_id: null,
  brand: null,
  imei: null,
  serial_code: null,
  model: null,
  status: null,
  contract_id: null,
  iccid: null,
  phone_number: null,
  activated_at: null,
  assigned_at: null,
  query: null,
  product_id: null,
  type: null,
  location: null,
  contract_start_at: {
    start: null,
    end: null,
  },
  contract_end_at: {
    start: null,
    end: null,
  },
  has_kasko: null,
  is_spare: null,
  customer_user_id: null,
}

const state = {
  statuses: [
    'Spedito',
    'Distribuito',
    'Assegnato',
    'Consegnato',
    'Sostituito',
    'In riparazione',
    'Scorta Calda',
    'Furto/Smarrimento',
    'Smarrito / Rubato',
    'Da Riconsegnare',
    'Da Riconsegnare a Chg'
  ],
}

const dropdownScopes = ['dropdown']
const sortDropdownBy = ['brand', 'model', 'serial_code']
const sortDropdownDesc = [false, false, false]

const getIdentifier = (asset) => asset.serial_code || asset.imei
const getAssetText = (asset) => {
  return `${asset.brand} ${asset.model} (${getIdentifier(asset)})`
}
const getters = {
  getListDropdown(state) {
    return state.list.map((l) => ({
      value: l.id,
      text: getAssetText(l),
      ...l,
    }))
  },
}

export default storeFactory({
  apiResourceName,
  modelName,
  model,
  filters,
  state,
  getters,
  dropdownScopes,
  sortDropdownBy,
  sortDropdownDesc,
})
